import {gql} from 'apollo-angular';
import {ProfessionPreviewFragment} from "./fragments/ProfessionPreview";
import {ContactGalleryFragment} from "./fragments/ContactGallery";
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
import {ProfilePreviewFragment} from "./fragments/ProfilePreview";

export const GET_COMPANY_PROFILE_BY_ID = gql`
  query GetCompanyProfileById($id: Int, $uuid: String) {
    companyProfile(id: $id, uuid: $uuid) {
      id
      name
      uuid
      description
      founded
      quizUrl
      logoStyle
      headerPicture {
        ...imageFields
      }
      companyProfilePicture {
        ...imageFields
      }
      locations {
        name
        address {
          street
          number
          addressCity {
            name
            addressDistrict {
              name
            }
          }
          addressLatLon {
            lat
            lon
          }
        }
      }
      jobs {
        ...professionPreviewFields,
      }
      companySize {
        id
        name
        text
      }
      certificates {
        id
        name
        picturePath
      }
      companyBenefits {
        id
        name
      }
      trainingInformation
      url
      contactGallery {
        ...contactGalleryFields
      }
      profileLink {
        entries {
          linkType
          linkValue
        }
      }
      mediaGallery {
        ...mediaGalleryFields
      }
      documents {
        galleryItems {
          id
          contentType
          document {
            id
            filePath
            name
          }
        }
      }
      offers {
        offerType
        name
      }
      jobMarkets {
        id
        name
        positionType
        addresses {
          addressCity {
            name
          }
        }
        jobs {
          id
          bicID
          name
          interestFields {
            id
          }
        }
      }
      relatedCompanies {
        id
        uuid
        name
        companyBenefits {
          id
          name
        }
        companyProfilePicture {
          ...imageFields
        }
        jobs {
          id
          name
          interestFields {
            id
          }
        }
        locations {
          name
          address {
            street
            addressCity {
              name
              addressDistrict {
                name
              }
            }
            addressLatLon {
              lat
              lon
            }
          }
        }
      }
    }
  }
  ${ProfessionPreviewFragment}
  ${ContactGalleryFragment}
  ${ImageFragment}
  ${MediaGalleryFragment}
  ${ProfessionPreviewFragment}
`;
